"use client";
import { jsx as a } from "react/jsx-runtime";
import R, { forwardRef as s, useState as S, useLayoutEffect as C } from "react";
import { createPortal as _ } from "react-dom";
import { handleError as g, Context as y } from "./utils.js";
import { renderToString as E } from "react-dom/server";
import { useEnsuredForwardedRef as x } from "./use-ensured-forwarded-ref.js";
function T({ children: o = "", ...d }) {
  let t = "";
  return R.isValidElement(o) ? t = E(o) : typeof o == "string" && (t = o), /* @__PURE__ */ a("template", { ...d, dangerouslySetInnerHTML: { __html: t } });
}
function v({ root: o, children: d = null }) {
  return _(d, o);
}
function I(o) {
  return s(
    ({
      mode: t = "open",
      delegatesFocus: i = !1,
      styleSheets: f = [],
      ssr: n = !1,
      children: l = null,
      ...h
    }, u) => {
      const r = x(u), [e, m] = S(null), p = `node_${t}${i}`;
      return C(() => {
        if (r.current)
          try {
            if (typeof u == "function" && u(r.current), n) {
              const { shadowRoot: w } = r.current;
              m(w);
              return;
            }
            const c = r.current.attachShadow({
              mode: t,
              delegatesFocus: i
            });
            f.length > 0 && (c.adoptedStyleSheets = f), m(c);
          } catch (c) {
            g({ error: c, styleSheets: f, root: e });
          }
      }, [u, r, f]), /* @__PURE__ */ a(o.tag, { ref: r, ...h, children: (e || n) && /* @__PURE__ */ a(y.Provider, { value: e, children: n ? /* @__PURE__ */ a(T, { shadowroot: t, shadowrootmode: t, children: o.render({
        root: e,
        ssr: n,
        children: l
      }) }) : /* @__PURE__ */ a(v, { root: e, children: o.render({
        root: e,
        ssr: n,
        children: l
      }) }) }) }, p);
    }
  );
}
export {
  I as create
};
